import styled from "styled-components";

export const NewItemWrap = styled.div`
    .Add-item-header {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 10px;
        width: 100%;
        margin-bottom: 20px;
        .dropdownWrap {
            position: relative;
            width: 100%;
            max-width: 160px;
            background-color: #289a001a;
            text-align: center;
            padding: 8px 10px;
            border-radius: 25px;
            &.available {
                background-color: #289a001a;
            }
            &.unavailable {
                background-color: #feecdf;
            }
            .modal-dropdown {
                position: relative;
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 5px;
                margin: 0 auto;
                .dot {
                    width: 8px;
                    height: 8px;
                    background-color: green;
                    border-radius: 100%;
                    flex-shrink: 0;
                    @media (min-width: 992px) {
                        width: 12px;
                        height: 12px;
                    }
                }
                .available {
                    background: green;
                }
                .unavailable {
                    background: red;
                }
                .dropdown {
                    display: flex;
                    justify-content: space-between;
                    gap: 5px;
                    align-items: center;
                    position: relative;
                    font-size: 16px;
                    line-height: 20px;
                    font-weight: 300;
                    color: green;
                    cursor: pointer;
                    position: relative;
                    @media (min-width: 992px) {
                        font-size: 18px;
                        line-height: 22px;
                    }
                    .available {
                        color: green;
                        background: transparent;
                    }
                    .unavailable {
                        color: red;
                        background: transparent;
                    }
                    p {
                        margin: 0;
                    }
                }
                .styled-select {
                    position: absolute;
                    top: 35px;
                    left: 0;
                    width: 140px;
                    background: var(--white);
                    border: 1px solid var(--gray-tune, #dfdfdf);
                    border-radius: 8px;
                    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
                    text-align: left;
                    font-size: 16px;
                    line-height: 22px;
                    font-weight: 300;
                    padding: 10px 0;
                    z-index: 1;
                    .available {
                        color: green;
                        background: transparent;
                    }
                    .unavailable {
                        color: red;
                        background: transparent;
                    }
                    li {
                        padding: 5px 15px;
                        cursor: pointer;
                        color: #313131;
                        &:hover {
                            background: var(--primary);
                            color: var(--white);
                        }
                    }
                }
            }
        }
    }
    .fieldsWrap {
        border-bottom: 1px solid #ececec;
        margin-bottom: 20px;
    }
    .user-fields {
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        margin-bottom: 20px;
        @media (min-width: 768px) {
            gap: 20px;
            grid-template-columns: repeat(2, 1fr);
        }
        .offers {
            &.ingredients-wrap {
                margin-bottom: 20px;
            }

            strong {
                display: block;
                margin-bottom: 10px;
            }
            .user-fields {
                position: relative;
                .swtichToggle {
                    position: absolute;
                    z-index: 2;
                    top: 100px;
                    right: 0;
                    @media (min-width: 768px) {
                        top: 0;
                    }
                }
            }
            .variations {
                display: flex;
                justify-content: flex-start;
                align-items: flex-start;
                flex-wrap: wrap;
                gap: 15px;
                margin-bottom: 10px;
                button {
                    background-color: transparent;
                    border: 1px solid #cdcdcd;
                    color: var(--black);
                }
            }
            .btn-wrap {
                button {
                    width: 100%;
                    /* background-color: #cdcdcd; */
                    /* color: var(--white); */
                    padding: 10px;
                }
            }
        }
    }
    .choice-group {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        gap: 10px;
        margin-bottom: 20px;
        .text {
            strong {
                margin-bottom: 10px;
                display: block;
            }
        }
        .create-choice-btn {
            button {
                background-color: transparent;
                border: 1px solid #cdcdcd;
                color: ${({theme}) => theme?.light?.primary};
                svg {
                    width: 10px;
                    height: 10px;
                }
            }
        }
    }
    .choice-wrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        gap: 20px;
        margin-bottom: 20px;
        box-shadow: rgba(0, 0, 0, 0.1) 0px 3px 8px;
        border-radius: 15px;
        padding: 15px;
        .choice {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            gap: 10px;
        }
        button {
            background-color: ${({theme}) => theme?.light?.primary50};
            color: var(--black);
            width: 100px;
            padding: 8px 15px;
        }
    }
    .btn-holder {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 20px;
    }
`;
export const Checkbox = styled.input.attrs({type: "checkbox"})`
    accent-color: ${({theme}) => theme?.light?.primary};
    appearance: none;
    width: 20px;
    height: 20px;
    border-radius: 4px;
    border: 1px solid #e1e4e8;
    background-color: var(--white);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    &:checked {
        background-color: ${({theme}) => theme?.light?.primary};
        border: none;
        &::after {
            content: "✓";
            color: var(--white);
            font-size: 14px;
        }
    }
`;
